(function () {
  if (window.__tkInfinite) return;
  window.__tkInfinite = true;

  function gridEl(root) {
    var scope = root || document;
    return (
      scope.querySelector('ul#product-grid') ||
      scope.querySelector('#product-grid.product-grid') ||
      scope.querySelector('ul.product-grid')
    );
  }

  function findNextUrl(scope) {
    var root = scope || document;
    var wrap = root.querySelector('[data-tk-infinite-root][data-next-url]');
    if (wrap) {
      var u = wrap.getAttribute('data-next-url');
      if (u) return u;
    }
    var a =
      root.querySelector('.pagination a[rel="next"]') ||
      root.querySelector('a.pagination__item--next') ||
      root.querySelector('.pagination__item--next a') ||
      root.querySelector('nav.pagination a[aria-label*="Sonraki"]') ||
      root.querySelector('nav.pagination a[aria-label*="Next"]');
    return a ? a.href : '';
  }

  function hidePagers() {
    document.querySelectorAll('nav.pagination, .pagination-wrapper').forEach(function (el) {
      if (el.closest('[data-tk-group-pager]')) return;
      el.classList.add('tk-pager-hidden');
      el.setAttribute('hidden', '');
      el.style.display = 'none';
    });
  }

  function appendFromHtml(html, grid) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incoming = gridEl(doc);
    if (!incoming) return { count: 0, next: '' };
    var n = 0;
    Array.prototype.slice.call(incoming.children).forEach(function (li) {
      if (!li.classList || !li.classList.contains('grid__item')) return;
      grid.appendChild(document.importNode(li, true));
      n++;
    });
    var next = findNextUrl(doc);
    if (window.tkMarket && typeof window.tkMarket.syncFavButtons === 'function') {
      window.tkMarket.syncFavButtons(grid);
    }
    return { count: n, next: next };
  }

  function bind(grid) {
    if (!grid || grid.dataset.tkInfiniteBound === '1') return;
    if (grid.getAttribute('data-tk-group')) return;
    var nextUrl = findNextUrl(document);
    if (!nextUrl) return;
    grid.dataset.tkInfiniteBound = '1';
    hidePagers();

    var parent = grid.parentElement;
    var sentinel = parent && parent.querySelector('[data-tk-infinite-sentinel]');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.setAttribute('data-tk-infinite-sentinel', '1');
      sentinel.className = 'tk-infinite-sentinel';
      sentinel.innerHTML = '<span class="tk-infinite-spinner">Daha fazla yükleniyor…</span>';
      if (parent) parent.appendChild(sentinel);
    }
    sentinel.hidden = false;
    var spinner = sentinel.querySelector('.tk-infinite-spinner');
    var loading = false;
    var done = false;

    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      if (loading || done || !nextUrl) return;
      loading = true;
      if (spinner) spinner.hidden = false;
      var url = nextUrl;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var res = appendFromHtml(html, grid);
          if (res.next && res.next !== url) {
            nextUrl = res.next;
            var wrap = document.querySelector('[data-tk-infinite-root]');
            if (wrap) wrap.setAttribute('data-next-url', nextUrl);
          } else {
            done = true;
            nextUrl = '';
            io.disconnect();
            sentinel.hidden = true;
          }
        })
        .catch(function () {})
        .finally(function () {
          loading = false;
          if (spinner) spinner.hidden = true;
        });
    }, { rootMargin: '700px 0px' });

    io.observe(sentinel);
  }

  function boot() {
    var grid = gridEl();
    if (grid) bind(grid);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  var host = document.getElementById('ProductGridContainer');
  if (host) {
    new MutationObserver(function () {
      var grid = gridEl();
      if (grid && grid.dataset.tkInfiniteBound !== '1') bind(grid);
    }).observe(host, { childList: true, subtree: true });
  }
})();
